import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import React from "react";

import { HEADER_MENU_HEIGHT } from "config/constants";
import { Typography } from "new-components/typography/Typography";

interface SelectDetectorFilterProps {
  valueMenu: string;
  setValueMenu: (val: string) => void;
  numDetectors: number;
}

const options = [
  {
    id: "1",
    name: "All Detectors",
    value: "",
  },
  {
    id: "2",
    name: "Active Detectors",
    value: "true",
  },
  {
    id: "3",
    name: "Inactive Detectors",
    value: "false",
  },
];

export function SelectDetectorFilter(props: SelectDetectorFilterProps) {
  const { valueMenu, setValueMenu, numDetectors } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickSelect = (value: string) => {
    setValueMenu(value);
    handleClose();
  };

  const getNameValue = (value: string) => options.find((i) => i.value === value)?.name;

  return (
    <Box>
      <Button
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClickOpen}
        // endIcon={<KeyboardArrowDownIcon width={20} height={20} />}
        className="flex items-center gap-2 text-white"
      >
        <MenuIcon width={20} height={20} />
        <Typography variant="subtitle" fontWeight="semibold" textTransform="uppercase">
          {getNameValue(valueMenu)}
        </Typography>
        <KeyboardArrowDownIcon width={20} height={20} />
        <Box>
          <Typography variant="subtitle" textTransform="uppercase">
            {`(${numDetectors || "-"})`}
          </Typography>
        </Box>
      </Button>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: HEADER_MENU_HEIGHT * 4.5,
            minWidth: 300,
          },
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.id} selected={option.id === valueMenu} onClick={() => handleClickSelect(option.value)}>
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
